import Entity from '../entity'

export default class Topic extends Entity<number> {
    title:string = "";
    systemName:string = "";
    isStatic:boolean = false;
    topicBody:string = '';
}